import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form/immutable';

import BasicForm from './BasicForm';
import Input from '../common/Input';
import Checkbox from '../common/Checkbox';
import DatePickerInput from '../common/DatePickerInput';
import * as constraints from '../../utils/constraints';

const TeacherForm = ({ handleSubmit, graduatedTeacher, specialTeacher, submitting }) => (
  <form onSubmit={handleSubmit}>
    <BasicForm submitting={submitting}>
      <div className="dinamic-container">
        <div>
          <Field
            name="graduated"
            label="Recibido"
            component={Checkbox}
          />
        </div>
        { graduatedTeacher ?
          <div>
            <Field
              name="graduationDate"
              label="Fecha de recibido"
              showYearDropdown
              placeholder="DD/MM/AAAA"
              component={DatePickerInput}
            />
          </div>
          :
          <div>
            <Field
              name="pendingSubjects"
              label="Materias pendientes"
              type="text"
              placeholder="Ej: Pedagogía, Matemática"
              component={Input}
            />
          </div>
        }
      </div>
      <div>
        <Field
          name="yearsOfExperience"
          label="Años de experiencia"
          component={Input}
          type="number"
        />
      </div>
      <div className="dinamic-container">
        <div>
          <Field
            name="specialTeacher"
            label="Docente Especial"
            component={Checkbox}
          />
        </div>
        {
          specialTeacher &&
          <div>
            <Field
              name="area"
              label="Area"
              type="text"
              placeholder="Ej: Música"
              component={Input}
            />
          </div>
        }
      </div>
    </BasicForm>
  </form>
);

const { func, bool } = PropTypes;

TeacherForm.propTypes = {
  handleSubmit: func.isRequired,
  graduatedTeacher: bool,
  specialTeacher: bool,
  submitting: bool
};

export default reduxForm({
  form: 'signUp',
  validate: constraints.validations(constraints.teacher)
})(TeacherForm);



// WEBPACK FOOTER //
// ./src/components/user/TeacherForm.js